import { mainSlice } from "@/app/providers/redux/reducer";
import store from "@/app/providers/redux/store";
const createSetter = (action) => {
    return (value) => store.dispatch(action(value));
};
export const setFlags = createSetter(mainSlice.actions.setFlags);
export const setLoader = createSetter(mainSlice.actions.setLoader);
export const setCategoryTitle = createSetter(mainSlice.actions.setCategoryTitle);
export const setShowCart = createSetter(mainSlice.actions.setShowCart);
export const setShowToast = createSetter(mainSlice.actions.setShowToast);
export const setToastMessage = createSetter(mainSlice.actions.setToastMessage);
export const setCart = createSetter(mainSlice.actions.setCart);
